import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Probleme from './components/Probleme';
import Solution from './components/Solution';
import Avantages from './components/Avantages';
import Processus from './components/Processus';
import Temoignages from './components/Temoignages';
import CTAFinal from './components/CTAFinal';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="font-montserrat">
      <Navbar />
      <Hero />
      <Probleme />
      <Solution />
      <Avantages />
      <Processus />
      <Temoignages />
      <CTAFinal />
      <Footer />
    </main>
  );
}
